import { Pipe, PipeTransform } from '@angular/core'
/* 
Transform the hotness score of a mix to one out of ten
that includes the fire emoji if the hotness is >=8
*/

@Pipe({name: 'formatHotness'})
export class HotnessPipe implements PipeTransform {
  transform(value: string): string {
    let hotness = value;
    return hotness >= '8' ? `${hotness}/10 🔥` : `${hotness}/10`
  }
}


// WEBPACK FOOTER //
// /Users/martyndavies/code/algolia/essentialvault-angular/src/app/helpers/hotness.pipe.ts